import { fetchQuery, graphql } from "relay-runtime"
import {
  AiRequestMetadataInput,
  chCallTranscriptSummarizerQuery as ChCallTranscriptSummarizerQuery,
} from "@/modules/patients/detail/progress-note/services/ch/__generated__/chCallTranscriptSummarizerQuery.graphql"
import { RelayEnvironment } from "@/relay-environment"

const query = graphql`
  query chCallTranscriptSummarizerQuery($aiRequestMetadata: AiRequestMetadataInput!) {
    summarizeCallTranscript: ch_summarizeCallTranscript(aiRequestMetadata: $aiRequestMetadata) {
      text
      result
      fileHash
      aiRequestDurationMs
      aiAnonymizationRequestDurationMs
    }
  }
`

export const chCallTranscriptSummarizerQuery = (aiRequestMetadata: AiRequestMetadataInput) => {
  return fetchQuery<ChCallTranscriptSummarizerQuery>(RelayEnvironment, query, {
    aiRequestMetadata,
  }).toPromise()
}
